import React from 'react';
import {useStyles} from '../../../../hooks/styles';
import {useAlign} from '../../../../theme/helpers';
import Animated from 'react-native-reanimated';

export const InputIconWrapper: React.FC<any> = ({style, children}) => {
  const align = useAlign();
  const styles = useStyles(() => ({
    container: {
      width: align(32),
      height: align(24),
      alignItems: 'center',
      justifyContent: 'center',
    },
  }));

  // У обыного View есть баг с динамическим изменением transform стиля
  return <Animated.View style={[styles.container, style]}>{children}</Animated.View>;
};
